module.exports = __webpack_public_path__ + "img/four-section-yxgh.7ee4ace3.png";